import React from 'react';
import PropTypes from 'prop-types';
import { Button, Select } from 'semantic-ui-react';
import { Trans, withTranslation } from 'react-i18next';
import AttendeesActions from '../actions/actions';

export function SelectButtons({ selectAll, deselectAll, selectedAttendees }) {
    return (
        <React.Fragment>
            <Button onClick={selectAll}>
                <Trans i18nKey="attendees.select">Select all</Trans>
            </Button>
            <Button disabled={!selectedAttendees.length} onClick={deselectAll}>
                <Trans i18nKey="ticket.common.action.deselect-all">Deselect all</Trans>
                {selectedAttendees.length ? ` (${selectedAttendees.length})` : null}
            </Button>
        </React.Fragment>
    );
}

SelectButtons.propTypes = {
    deselectAll: PropTypes.func.isRequired,
    selectAll: PropTypes.func.isRequired,
    selectedAttendees: PropTypes.array.isRequired
};

/**
 * Select input to pick a given action for the selected attendees
 */
class ActionPicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: ''
        };
    }

    /**
     * Gets the actions for the dropdown and calculates if they are disabled
     * based on selected attendees
     */
    getActions() {
        let { event, selectedAttendees, showSwap, t } = this.props;
        let actions = AttendeesActions.filter(action => (action.displayed ? action.displayed(event, showSwap) : true)).map(action => ({
            value: action.name,
            text: t(action.label),
            disabled: action.disabled ? action.disabled(selectedAttendees, showSwap) : false,
            onMouseOver: () => (action.onMouseOver ? action.onMouseOver(selectedAttendees, this.forceUpdate.bind(this)) : undefined),
            onMouseOut: () => (action.onMouseOut ? action.onMouseOut(selectedAttendees, this.forceUpdate.bind(this)) : undefined)
        }));

        actions.unshift({
            value: '',
            text: t('attendees.actions.selectOneAction')
        });

        return actions;
    }

    onChange(value) {
        this.setState({ value }, () => {
            this.props.onChange(this.state.value);
            setTimeout(() => {
                this.setState({ value: '' });
            }, 100);
        });
    }

    render() {
        const { t } = this.props;
        return (
            <Select
                placeholder={t('attendees.actions.selectOneAction')}
                className="attendees-actions-selector"
                clearable={true}
                disabled={!this.props.selectedAttendees.length}
                options={this.getActions()}
                value={this.state.value}
                onChange={(synthetic, { value }) => this.onChange(value)}
            />
        );
    }
}

ActionPicker.defaultProps = {
    showSwap: true
};

ActionPicker.propTypes = {
    event: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    selectedAttendees: PropTypes.array.isRequired,
    showSwap: PropTypes.bool,
    t: PropTypes.func.isRequired
};

export default withTranslation()(ActionPicker);
